import React from 'react';
export var ButtonVariant;
(function (ButtonVariant) {
    ButtonVariant[ButtonVariant["Normal"] = 0] = "Normal";
    ButtonVariant[ButtonVariant["Success"] = 1] = "Success";
    ButtonVariant[ButtonVariant["Warning"] = 2] = "Warning";
    ButtonVariant[ButtonVariant["Danger"] = 3] = "Danger";
})(ButtonVariant || (ButtonVariant = {}));
export class Button extends React.Component {
    constructor() {
        super(...arguments);
        this.render = () => {
            let colorStyle = '';
            switch (this.props.variant) {
                case ButtonVariant.Success:
                    colorStyle =
                        'bg-green-600 hover:bg-green-500 focus:bg-green-500 active:bg-green-600 focus:shadow-outline-green-600';
                    break;
                case ButtonVariant.Warning:
                    colorStyle =
                        'bg-yellow-600 hover:bg-yellow-500 focus:bg-yellow-500 active:bg-yellow-600 focus:shadow-outline-yellow-600';
                    break;
                case ButtonVariant.Danger:
                    colorStyle =
                        'bg-red-600 hover:bg-red-500 focus:bg-red-500 active:bg-red-600 focus:shadow-outline-red-600';
                    break;
                case ButtonVariant.Normal:
                default:
                    colorStyle =
                        'bg-primary-600 hover:bg-primary-500 focus:bg-primary-500 active:bg-primary-600 focus:shadow-outline-primary-600';
                    break;
            }
            if (this.props.disabled) {
                colorStyle = 'bg-base-600';
            }
            return (React.createElement(React.Fragment, null,
                React.createElement("button", { disabled: this.props.disabled, onClick: this.props.onClick, className: `${this.props.className} block px-6 py-2 text-sm font-medium leading-5 text-center text-white ${colorStyle} border border-transparent rounded-lg focus:outline-none transition-colors duration-150`, style: this.props.style }, this.props.label)));
        };
    }
}
